module.exports = __webpack_public_path__ + "static/media/kc-jjjenkins.a7b0c955.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode/images/kittycash/kc-jjjenkins.png
// module id = 1569
// module chunks = 0